export const occupationSelect = [
  {
    value: "null",
    label: "職業を選択してください",
  },
  {
    value: "1",
    label: "お勤め（会社員、公務員など）",
  },
  {
    value: "2",
    label: "自営業",
  },
  {
    value: "3",
    label: "学生",
  },
  {
    value: "4",
    label: "主婦・主夫（パート含む）",
  },
  {
    value: "5",
    label: "無職",
  },
];

export const workAddressSelect = [
  { value: "0", label: "都道府県を選択してください" },
  { value: "1", label: "北海道" },
  { value: "2", label: "青森県" },
  { value: "3", label: "岩手県" },
  { value: "4", label: "宮城県" },
  { value: "5", label: "秋田県" },
  { value: "6", label: "山形県" },
  { value: "7", label: "福島県" },
  { value: "8", label: "茨城県" },
  { value: "9", label: "栃木県" },
  { value: "10", label: "群馬県" },
  { value: "11", label: "埼玉県" },
  { value: "12", label: "千葉県" },
  { value: "13", label: "東京都" },
  { value: "14", label: "神奈川県" },
  { value: "15", label: "新潟県" },
  { value: "16", label: "富山県" },
  { value: "17", label: "石川県" },
  { value: "18", label: "福井県" },
  { value: "19", label: "山梨県" },
  { value: "20", label: "長野県" },
  { value: "21", label: "岐阜県" },
  { value: "22", label: "静岡県" },
  { value: "23", label: "愛知県" },
  { value: "24", label: "三重県" },
  { value: "25", label: "滋賀県" },
  { value: "26", label: "京都府" },
  { value: "27", label: "大阪府" },
  { value: "28", label: "兵庫県" },
  { value: "29", label: "奈良県" },
  { value: "30", label: "和歌山県" },
  { value: "31", label: "鳥取県" },
  { value: "32", label: "島根県" },
  { value: "33", label: "岡山県" },
  { value: "34", label: "広島県" },
  { value: "35", label: "山口県" },
  { value: "36", label: "徳島県" },
  { value: "37", label: "香川県" },
  { value: "38", label: "愛媛県" },
  { value: "39", label: "高知県" },
  { value: "40", label: "福岡県" },
  { value: "41", label: "佐賀県" },
  { value: "42", label: "長崎県" },
  { value: "43", label: "熊本県" },
  { value: "44", label: "大分県" },
  { value: "45", label: "宮崎県" },
  { value: "46", label: "鹿児島県" },
  { value: "47", label: "沖縄県" },
  { value: "48", label: "海外" },
];

export const generalEnterprise = [
  { label: "食品・飲料", value: "3" },
  { label: "家庭用品・トイレタリー", value: "4" },
  { label: "化粧品", value: "5" },
  { label: "アパレル", value: "6" },
  { label: "医薬品", value: "7" },
  { label: "レジャー・エンタメ", value: "8" },
  { label: "外食・宿泊", value: "9" },
  { label: "流通・小売", value: "10" },
  { label: "情報・通信", value: "11" },
  { label: "自動車", value: "12" },
  { label: "電機・精密機器", value: "13" },
  { label: "素材", value: "14" },
  { label: "エネルギー", value: "15" },
  { label: "建設・不動産", value: "16" },
  { label: "住宅・住宅設備", value: "17" },
  { label: "運輸・交通", value: "18" },
  { label: "金融・保険", value: "19" },
  { label: "商社", value: "20" },
  { label: "医療・福祉", value: "22" },
  { label: "学校・教育", value: "23" },
  { label: "シンクタンク・コンサルティング", value: "24" },
  { label: "人材サービス", value: "25" },
  { label: "非営利法人", value: "26" },
  { label: "官公庁・行政", value: "27" },
  { label: "その他", value: "30" },
];

export const advertisingAndMarketing = [
  { label: "広告会社", value: "31" },
  { label: "広告制作会社", value: "32" },
  { label: "印刷会社", value: "33" },
  { label: "SP・イベント会社", value: "35" },
  { label: "PR会社", value: "36" },
  { label: "マーケティング支援・リサーチ", value: "37" },
  { label: "Web制作会社", value: "38" },
  { label: "デジタルマーケティング支援", value: "39" },
  { label: "その他", value: "40" },
];

export const media = [
  { label: "テレビ（衛星含む）", value: "41" },
  { label: "ウェブメディア", value: "42" },
  { label: "新聞", value: "43" },
  { label: "出版", value: "44" },
  { label: "ラジオ", value: "45" },
  { label: "その他", value: "46" },
];

export const generalIndustoryCode = [
  { label: "職種を選択してください", value: "0" },
  { label: "マーケティング", value: "2" },
  { label: "宣伝・広告", value: "1" },
  { label: "販売促進", value: "3" },
  { label: "営業・営業企画", value: "4" },
  { label: "広報・IR", value: "5" },
  { label: "クリエイティブ", value: "13" },
  { label: "ウェブ", value: "6" },
  { label: "情報システム", value: "7" },
  { label: "カスタマーサポート・CRM", value: "8" },
  { label: "総務・経理", value: "9" },
  { label: "人事", value: "10" },
  { label: "法務", value: "11" },
  { label: "経営企画", value: "12" },
  { label: "役員・取締役", value: "14" },
  { label: "その他", value: "15" },
];

export const generalSocialTrendsCode = [
  { label: "政策（経済・社会・労働政策など）", value: "0101" },
  { label: "環境（エネルギー、サスティナブルなど）", value: "0102" },
  { label: "テクノロジー　", value: "0103" },
  { label: "生活者（世代意識など）", value: "0104" },
  { label: "コンテスト・アワード情報", value: "0105" },
  { label: "流行/重要トピックス", value: "0106" },
];

export const generalOrganizationAndSkillsKnowledge = [
  { label: "経営", value: "030101" },
  { label: "会計", value: "030102" },
  { label: "人事・人材開発", value: "030103" },
  { label: "事業開発", value: "030201" },
  { label: "事業計画", value: "030202" },
  { label: "DX・デジタルマーケティング", value: "030301" },
  { label: "マス広告/リアル接点広告", value: "030302" },
  { label: "マーケティング", value: "030303" },
  { label: "CRM", value: "030304" },
  { label: "商品開発/プロダクト開発", value: "030305" },
  { label: "セールス", value: "030306" },
  { label: "サービス", value: "030307" },
  { label: "広報・PR", value: "030308" },
  { label: "販売促進・プロモーション", value: "030309" },
  { label: "メディアバイイング/プラニング", value: "030310" },
  { label: "クリエイティブ（デザイン、コピーなど）", value: "030311" },
  { label: "データマネジメント/ガバナンス", value: "030312" },
  { label: "エンジニアリング", value: "030313" },
  { label: "プロジェクト/プロダクトマネジメント（PM/PdM）", value: "030314" },
];

export const generalWorkAndLifePlanning = [
  { label: "ビジネスパーソンスキル", value: "0401" },
  { label: "キャリアデザイン（転職、リスキリング）", value: "0402" },
  { label: "ワークデザイン（ワークスタイル、稼ぎ方）", value: "0403" },
  { label: "ライフデザイン（趣味、幸福感）", value: "0404" },
];

export const environmentalManagementJobs = [
  { label: "ESG、SDGs、GX", value: "01020101" },
  { label: "CO2算定", value: "01020102" },
  { label: "サステナビリティ情報開示", value: "01020103" },
  { label: "環境経営全般", value: "01020199" },
];

export const carbonNeutralJobs = [
  { label: "非化石エネルギー転換", value: "01020201" },
  { label: "設備改修・投資", value: "01020202" },
  { label: "カーボンクレジット", value: "01020203" },
  { label: "Scope3対策", value: "01020204" },
  { label: "CO2排出削減、カーボンニュートラル全般", value: "01020299" },
];

export const solarPowerJobs = [
  { label: "産業用太陽光発電事業", value: "01020301" },
  { label: "PPA事業", value: "01020302" },
  { label: "屋根貸し事業", value: "01020303" },
  { label: "セカンダリー売買", value: "01020304" },
  { label: "住宅用太陽光発電", value: "01020305" },
  { label: "パネル、モジュール", value: "01020306" },
  { label: "架台", value: "01020307" },
  { label: "パワコン", value: "01020308" },
  { label: "監視・メンテナンス", value: "01020309" },
  { label: "太陽光発電全般", value: "01020399" },
];

export const energyBusinessJobs = [
  { label: "電力小売", value: "01020401" },
  { label: "VPP、アグリゲーション", value: "01020402" },
  { label: "風力発電", value: "01020403" },
  { label: "地熱発電", value: "01020404" },
  { label: "バイオマス・バイオガス発電", value: "01020405" },
  { label: "水力発電", value: "01020406" },
  { label: "水素、アンモニア、メタネーション", value: "01020407" },
  { label: "蓄電ビジネス", value: "01020408" },
  { label: "CO2吸収、利活用（CCS・CCUS）", value: "01020409" },
  { label: "エネルギー事業全般", value: "01020499" },
];

export const energySavingEquipmentJobs = [
  { label: "LED", value: "01020501" },
  { label: "空調設備・冷熱機器", value: "01020502" },
  { label: "再エネ発電設備", value: "01020503" },
  { label: "石油・ガス発電", value: "01020504" },
  { label: "排熱・潜熱回収", value: "01020505" },
  { label: "ボイラー", value: "01020506" },
  { label: "パッシブデザイン", value: "01020507" },
  { label: "エコカー、充電器", value: "01020508" },
  { label: "エネマネ、蓄電設備、ZEB、ZEH", value: "01020509" },
  { label: "スマートメータ、排出量可視化", value: "01020510" },
  { label: "省エネ設備全般", value: "01020599" },
];

export const circularEconomyJobs = [
  { label: "廃棄物処理", value: "01020601" },
  { label: "再プラ、プラごみ削減", value: "01020602" },
  { label: "リサイクル", value: "01020603" },
  { label: "グリーンインフラ、スマートシティ", value: "01020604" },
  { label: "循環型経済全般", value: "01020699" },
];

export const chemicalAndPollutionJobs = [
  { label: "廃棄物管理", value: "01020701" },
  { label: "排ガス浄化", value: "01020702" },
  { label: "水処理", value: "01020703" },
  { label: "化学物質規制", value: "01020704" },
  { label: "化学物質・公害全般", value: "01020799" },
];

export const otherEnvironmentalJobs = [
  { label: "DAC（直接空気回収）", value: "01029901" },
  { label: "生物多様性", value: "01029902" },
  { label: "農林水産", value: "01029903" },
  { label: "環境価値取引", value: "01029904" },
  { label: "地方行政", value: "01010499" },
  { label: "その他環境テーマ全般", value: "01029999" },
  { label: "当てはまるものはない", value: "0" },
];

export const generalClimateChangeCode = [
  { label: "生態系モニタリング", value: "01020101" },
  { label: "気候変動リスク", value: "01020102" },
  { label: "温室効果ガス", value: "01020103" },
];

export const generalEnergyCode = [
  { label: "太陽光発電", value: "01020201" },
  { label: "電力サービス", value: "01020202" },
  { label: "再生エネルギー", value: "01020203" },
  { label: "水素・アンモニア", value: "01020204" },
  { label: "蓄電・省エネ", value: "01020205" },
  { label: "脱炭素経営", value: "01020206" },
  { label: "カーボンニュートラル", value: "01020207" },
  { label: "グリーンエネルギー", value: "01020208" },
];

export const generalCircularEconomyCode = [
  { label: "循環経済", value: "01020301" },
  { label: "SDGs", value: "01020302" },
  { label: "GX（グリーン・トランスフォーメーション）", value: "01020308" },
];

export const generalNatureConservationCode = [
  { label: "森林保護", value: "01020401" },
  { label: "海洋保護", value: "01020402" },
  { label: "生物多様性", value: "01020403" },
];

export const generalEnvironmentTrendsAndNewsCode = [
  { label: "経営・戦略", value: "030101" },
  { label: "DX・デジタル化", value: "03010101" },
  { label: "地方自治体　", value: "01010203" },
  { label: "人事", value: "03060301" },
];

export const generalOthersInterestCode = [
  { label: "CSR", value: "01029901" },
  { label: "ESG", value: "01029902" },
  { label: "その他", value: "999999" },
  { label: "当てはまるものはない", value: "0" },
];

export const generalManufacturingtCode = [
  { label: "食料品・飲料", value: "020201" },
  { label: "アパレル", value: "020202" },
  { label: "日用品・トイレタリー", value: "020203" },
  { label: "化粧品", value: "020204" },
  { label: "電気機器（家電など）", value: "020205" },
  { label: "自動車", value: "020206" },
  { label: "医薬品", value: "020207" },
];

export const generaSpecializedServicesConsultingCode = [
  { label: "コンサル・シンクタンク業", value: "020901" },
  { label: "広告業", value: "020902" },
  { label: "クリエイティブ・デザイン制作業", value: "020903" },
];

export const generaEnergyAndWaterIndustryCode = [
  { label: "電気業", value: "020301" },
  { label: "ガス業", value: "020302" },
];

export const generaCommunicationsAndProductionCode = [
  { label: "通信業（3大キャリア、格安スマホなど）", value: "020401" },
  { label: "放送業（テレビ、ラジオなど）", value: "020402" },
  { label: "SNS（Facebook、X、Instagramなど）", value: "020403" },
  { label: "情報通信サービス（記事、情報サイトなど）", value: "020404" },
  { label: "IT・ソフトウェア開発", value: "020405" },
];

export const generaFinanceAndInsuranceCode = [
  { label: "銀行員", value: "020701" },
  { label: "保険業", value: "020702" },
];

export const generaLodgingAndFoodServicesCode = [
  { label: "宿泊業（ホテル、リゾートなど）", value: "021001" },
  { label: "飲食店/持ち帰り・配達飲食サービス業", value: "021002" },
];

export const generaLifeAndLeisureServicesCode = [
  { label: "旅行業", value: "021101" },
  { label: "娯楽業（ゲーム、遊園地、娯楽施設など）", value: "021102" },
];

export const generaOtherIndustriesCode = [
  { label: "建設業（ゼネコン、土木など）", value: "0201" },
  { label: "通運業・郵便業（鉄道、宅配など）", value: "0205" },
  { label: "卸売業・小売業（スーパー、ドラッグ、ECなど）", value: "0206" },
  { label: "不動産取引業", value: "020801" },
  { label: "補助教育、技能教育（通信教育、塾など）", value: "021201" },
  { label: "当てはまるものはない", value: "0" },
];
export const positions = [
  { label: "新入社員（1年目）", value: "010100" },
  { label: "若手社員（2〜5年目）", value: "010200" },
  { label: "一般社員（6年目以上、かつ、非管理職）", value: "010300" },
  { label: "係長", value: "010400" },
  { label: "課長", value: "020500" },
  { label: "部門長・部長", value: "020600" },
  { label: "執行役員", value: "020700" },
  { label: "専務・常務", value: "030800" },
  { label: "Cクラス（CEO以外）/取締役", value: "030901" },
  { label: "CEO/社長/副社長", value: "031001" },
  { label: "役職無し", value: "031002" },
];

export const businessAndManagementJobs = [
  { label: "金融・会計", value: "0224241" },
  { label: "経営（経営者・役員）", value: "0224242" },
  { label: "経営企画", value: "0112121" },
  { label: "事業企画・開発", value: "0224253" },
  { label: "人事", value: "0224243" },
  { label: "DX・デジタルマーケティング", value: "0224244" },
  { label: "広告宣伝・マーケティング", value: "0224245" },
  { label: "CRM", value: "0224246" },
  { label: "商品開発/研究開発・R&D", value: "0224247" },
  { label: "営業・セールス", value: "0224248" },
  { label: "カスタマーサービス", value: "0224249" },
  { label: "広報・IR", value: "0224250" },
  { label: "販売促進・プロモーション・イベント", value: "0224251" },
  { label: "メディアバイイング", value: "0224252" },
  { label: "法務", value: "0228252" },
];

export const creativeAndDesignJobs = [
  {
    label: "制作ディレクション・企画（CD・プロデューサーなど）",
    value: "0227271",
  },
  { label: "クリエイティブ制作（デザイン・コピーなど）", value: "0227272" },
  { label: "クリエイティブテクノロジー", value: "0227273" },
];

export const environmentAndInfrastructureJobs = [
  {
    label: "環境・CSR・サスティナブル推進",
    value: "022121412145",
  },
  { label: "生産/製造技術エンジニア", value: "022121412141" },
  { label: "サプライチェーン担当（購買・調達など）", value: "022121412142" },
  { label: "設備（建物）管理", value: "022121412143" },
  { label: "施工・工事", value: "02212141" },
];

export const informationAndTechnologyJobs1 = [
  { label: "フルスタックエンジニア", value: "022626112143" },
  { label: "ソフトウェア開発", value: "022626112613" },
  { label: "ウェブサイト開発", value: "022626112614" },
];

export const informationAndTechnologyJobs2 = [
  { label: "データベース設計開発", value: "022626212621" },
  { label: "データサイエンティスト/アナリスト", value: "022626212622" },
  { label: "システム管理者", value: "022626212623" },
];

export const other = [
  { label: "その他", value: "999999" },
  // { label: "学生", value: "888888" },
  { label: "当てはまるものはない", value: "0" },
];

export const NAV_LINKS = {
  Marketing: 1,
  Creative: 2,
  ChangeCareerAndRecruitment: 3,
  EnvironmentalBusiness: 4,
};

export const ROUTE_LABELS = {
  HOME: "ホーム",
  REGISTER_NEW: "新規会員登録",
  REGISTER_CONFIRM_SEND_EMAIL: "メールアドレス確認",
  REGISTER_SENT_EMAIL: "確認メール送信",
  REGISTER_COMPLETED: "会員登録完了",
  REGISTER: "会員登録",
  LOGIN: "会員ログイン",
};

export const componentMapping: { [key: number]: string[] } = {
  1: ["BasicInfo", "PositionInfo", "NewsletterSetting"],
  2: ["BasicInfo", "PositionInfo", "NewsletterSetting"],
  3: ["BasicInfo", "PositionInfo", "BasicInterests", "NewsletterSetting"],
  4: ["BasicInfo", "PositionInfo", "NewsletterSetting"],
  5: ["BasicInfo", "PositionInfo", "NewsletterSetting"],
  6: [
    "BasicInfo",
    "PositionInfo",
    "BasicInterests",
    "WorkPlace",
    "HomePlace",
    "NewsletterSetting",
  ],
  7: [],
  8: [],
  9: [
    "BasicInfo",
    "PositionInfo",
    "BasicInterests",
    "WorkPlace",
    "HomePlace",
    "NewsletterSetting",
  ],
  10: [
    "BasicInfo",
    "PositionInfo",
    "BasicInterests",
    "WorkPlace",
    "HomePlace",
    "NewsletterSetting",
  ],
  11: ["BasicInfo", "PositionInfo", "BasicInterests", "NewsletterSetting"],
  12: ["BasicInfo", "PositionInfo", "BasicInterests", "NewsletterSetting"],
  13: ["BasicInfo", "PositionInfo", "BasicInterests", "NewsletterSetting"],
  14: ["BasicInfo", "PositionInfo", "NewsletterSetting"],
  15: [
    "BasicInfo",
    "PositionInfo",
    "BasicInterests",
    "WorkPlace",
    "HomePlace",
    "NewsletterSetting",
  ],
  16: [
    "BasicInfo",
    "PositionInfo",
    "BasicInterests",
    "WorkPlace",
    "HomePlace",
    "NewsletterSetting",
  ],
};

export const mappingUser: string[] = [
  "BasicInfo",
  "PositionInfo",
  "BasicInterests",
  "WorkPlace",
  "HomePlace",
];

export const mappingNewUser: string[] = [
  "BasicInfo",
  "PositionInfo",
  "BasicInterests",
  "WorkPlace",
  "HomePlace",
  "NewsletterSetting"
];

export const SESSION_RES_TYPE = {
  EXPIRED: 1,
  ANOTHER_ERR: 2,
  REGISTSUCCESS: 3,
};

// export const PERSON_TITLE = {
//   EMPLOYEE: '一般社員クラス',
//   LEADER: '主任・係長クラス',
//   HEAD_OF_DEPARTMENT: '課長クラス',
//   MANAGER: '本部長・部長クラス',
//   GENERAL_DIRETOR: '経営者・役員クラス',
//  };

export const PERSON_TITLE = [
  { label: "一般社員クラス", values: ["010100", "010200", "010300"] },
  { label: "主任・係長クラス", values: ["010400"] },
  { label: "課長クラス", values: ["020500"] },
  { label: "本部長・部長クラス", values: ["020600", "020700"] },
  { label: "経営者・役員クラス", values: ["030800", "030901", "031001"] },
];
